import axios from 'axios';
import { format } from "date-fns";

import { get_cookies } from "../../components/Cookies/Cookies";

const branch_idno = get_cookies('branchidno'); //set branchidno into variable
const fetch_transaction_history = async(url, dateRange,sizePerpage, page, sort, sortorder, search, iscodesonly, filterOption,branch_idno) => {
    var parameters = {};
    switch(url){
      case "packagesalessummaryv2ready":
        parameters = ([''].includes(search)) ? {
          date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
          date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
          jc_user_id_no: get_cookies('branchidno'), //branch id no
          sizePerpage: sizePerpage,
          page: page,
          idno_filter: filterOption.idno_filter,
          relstats_filter: filterOption.relstats_filter,
          soldto_filter: filterOption.soldto_filter,
          accttype_filter: filterOption.accttype_filter,
          delivery_filter: filterOption.delivery_filter,
          package_filter: filterOption.package_filter,
          promo_filter: filterOption.promo_filter,
          country_filter: filterOption.country_filter,
          packstats_filter: filterOption.packstats_filter,
          iscodesonly: iscodesonly.iscodesonly,
          sort,
          sortorder
        }: {
          date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
          date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
          jc_user_id_no: get_cookies('branchidno'), //branch id no
          sizePerpage: sizePerpage,
          page: page,
          idno_filter: filterOption.idno_filter,
          relstats_filter: filterOption.relstats_filter,
          soldto_filter: filterOption.soldto_filter,
          accttype_filter: filterOption.accttype_filter,
          delivery_filter: filterOption.delivery_filter,
          package_filter: filterOption.package_filter,
          promo_filter: filterOption.promo_filter,
          country_filter: filterOption.country_filter,
          packstats_filter: filterOption.packstats_filter,
          iscodesonly: iscodesonly.iscodesonly,
          sort,
          sortorder,
          filter: ['', null, undefined, ' '].includes(search) ? null : 'search',
          search
        };
        break;
        case "wholesale_transaction_history":
          parameters = ([''].includes(search)) ? {
            date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
            date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
            jc_user_id_no: get_cookies('branchidno'), //branch id no
            sizePerpage: sizePerpage,
            page: page,
            idno_filter: filterOption.idno_filter,
            relstats_filter: filterOption.relstats_filter,
            soldto_filter: filterOption.soldto_filter,
            accttype_filter: filterOption.accttype_filter,
            delivery_filter: filterOption.delivery_filter,
            package_filter: filterOption.package_filter,
            promo_filter: filterOption.promo_filter,
            country_filter: filterOption.country_filter,
            packstats_filter: filterOption.packstats_filter,
            iscodesonly: iscodesonly.iscodesonly,
            sort,
            sortorder
          }: {
            date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
            date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
            jc_user_id_no: get_cookies('branchidno'), //branch id no
            sizePerpage: sizePerpage,
            page: page,
            idno_filter: filterOption.idno_filter,
            relstats_filter: filterOption.relstats_filter,
            soldto_filter: filterOption.soldto_filter,
            accttype_filter: filterOption.accttype_filter,
            delivery_filter: filterOption.delivery_filter,
            package_filter: filterOption.package_filter,
            promo_filter: filterOption.promo_filter,
            country_filter: filterOption.country_filter,
            packstats_filter: filterOption.packstats_filter,
            iscodesonly: iscodesonly.iscodesonly,
            sort,
            sortorder,
            filter: ['', null, undefined, ' '].includes(search) ? null : 'search',
            search
          };
          break;
      
      default:
        parameters = ([''].includes(search)) ? {
          date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
          date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
          jc_user_id_no: get_cookies('branchidno'), //branch id no
          sizePerpage: sizePerpage,
          page: page,
          position_id: get_cookies('position_id'),
          sort,
          sortorder
        } : {
          date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
          date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
          jc_user_id_no: get_cookies('branchidno'), //branch id no
          sizePerpage: sizePerpage,
          page: page,
          position_id: get_cookies('position_id'),
          sort,
          sortorder,
          filter: ['', null, undefined, ' '].includes(search) ? null : 'search',
          search
        };
        break;
    }
    try {
      let config = {
        method: 'GET',
        url: process.env.REACT_APP_API_URL+url,

        headers: {
          'Content-Type': 'application/json',
        },
        params: parameters
      };    
      const result = await axios(config);
      return await result.data;
    } catch (error) {
      return 'error';
    }
}


export {
  fetch_transaction_history
};